import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Store } from '../Store';
import { getError } from '../utils';
import LoadingBox from '../components/LoadingBox';
import MessageBox from '../components/MessageBox';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import { toast } from 'react-toastify';

export default function WaiterOrderScreen() {
    const navigate = useNavigate();
    const { state } = useContext(Store);
    const { userInfo } = state;
    const [tables, setTables] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchTables = async () => {
            try {
                setLoading(true);
                const { data } = await axios.get('/api/tables', {
                    headers: { Authorization: `Bearer ${userInfo.token}` },
                });
                setTables(data);
                setLoading(false);
            } catch (err) {
                setError(getError(err));
                setLoading(false);
            }
        };
        fetchTables();
    }, [userInfo]);

    const selectPointHandler = (table) => {
        // Redirect to DigitalMenu with table and business ID
        // Note: DigitalMenu handles table QR IDs. 
        // We use table.qrCodeId and table.restaurantId
        navigate(`/menu?table=${table.qrCodeId}&business=${table.restaurantId}`);
    };

    return (
        <Container className="py-4">
            <Helmet>
                <title>Waiter Order Panel</title>
            </Helmet>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1>Take Customer Order</h1>
                <Badge bg="info" className="p-2">Waiter: {userInfo.name}</Badge>
            </div>

            {loading ? (
                <LoadingBox />
            ) : error ? (
                <MessageBox variant="danger">{error}</MessageBox>
            ) : (
                <Row>
                    {tables.map((table) => (
                        <Col key={table._id} xs={6} md={4} lg={3} className="mb-4">
                            <Card
                                className={`h-100 shadow-sm border-0 point-card ${table.status === 'occupied' ? 'bg-light' : ''}`}
                                onClick={() => selectPointHandler(table)}
                                style={{ cursor: 'pointer', transition: 'transform 0.2s' }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.03)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            >
                                <Card.Body className="text-center">
                                    <div className="display-6 mb-2">
                                        {table.type === 'room' ? '🏨' : '🍽️'}
                                    </div>
                                    <h5 className="fw-bold mb-1">
                                        {table.type === 'room' ? 'Room' : 'Table'} {table.type === 'room' ? table.roomNumber : table.tableNumber}
                                    </h5>
                                    <div className="small text-muted mb-2">{table.location}</div>
                                    <Badge bg={table.status === 'occupied' ? 'danger' : 'success'} className="rounded-pill">
                                        {table.status === 'occupied' ? 'Occupied' : 'Available'}
                                    </Badge>
                                </Card.Body>
                                <Card.Footer className="bg-transparent border-0 pb-3 text-center">
                                    <Button size="sm" variant={table.status === 'occupied' ? "outline-primary" : "primary"}>
                                        {table.status === 'occupied' ? 'Update Order' : 'Start Order'}
                                    </Button>
                                </Card.Footer>
                            </Card>
                        </Col>
                    ))}
                    {tables.length === 0 && (
                        <Col className="text-center py-5">
                            <MessageBox>No tables or rooms found for your restaurant.</MessageBox>
                        </Col>
                    )}
                </Row>
            )}

            <style>{`
                .point-card.bg-light {
                    border-left: 4px solid #dc3545 !important;
                }
                .point-card:not(.bg-light) {
                    border-left: 4px solid #198754 !important;
                }
            `}</style>
        </Container>
    );
}
